var miscInit;

(function ($) {

	const selectors = {
		scrollTop: '[data-scroll-top]',
		scrollInidicator: '[data-scroll-indicator]'
	}

	miscInit = function () {

		$(selectors.scrollTop).click(function (e) {
			e.preventDefault();
			$('html, body').stop().animate({ scrollTop: 0 }, 1000);
		})

		$('a[href^="#"]:not([href="#"])').on('click', function (e) {
			e.preventDefault();

			const target_id = $(this).attr('href').slice(1);
			const $target = $('#' + target_id + ', [data-id="' + target_id + '"]').filter(':visible');

			if ($target.length) {
				$('html, body').stop().animate({ scrollTop: $target.offset().top - 100 }, 1000);
			}

		});

		$(selectors.scrollInidicator).on('click', function (e) {
			e.preventDefault();

			var $next_section = $(this).closest('main > *').next();
			if ($next_section.length) {

				$next_section = $next_section.first();

				const header_height = $(window).width >= 900 ? 80 : 70;
				const win_height = $(window).height() - header_height;
				const offTop = $next_section.offset().top - header_height - parseFloat($next_section.css('margin-top'));

				$('html, body').stop().animate({ scrollTop: offTop });
			}
		});

	}

})(jQuery);

export default miscInit;